import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var main = "EmailLink.js";
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n']);

var StyledLink = styled('a')(_templateObject$5, function (props) {
	return props.theme.colours.links;
}, function (props) {
	return props.theme.fonts.emailLink;
});

/**
 * Uses `<a>` tag internally, href is prefixed with "mailto &#58;"
 * @example ./Design.md
 */
var EmailLink = function EmailLink(_ref) {
	var email = _ref.email,
	    linkText = _ref.linkText;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, hasCustomMargins: true, layout: 'inline' },
		React.createElement(
			StyledLink,
			{ href: 'mailto:' + email, title: linkText },
			linkText || email
		)
	);
};

EmailLink.propTypes = {
	/** Displayed text. */
	linkText: PropTypes.string,
	/** Email address. */
	email: PropTypes.string.isRequired
};

EmailLink.defaultProps = {};

var main$1 = "PhoneLink.js";
var packageJson$1 = {
	main: main$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: ', ';\n\twhite-space: nowrap;\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: ', ';\n\twhite-space: nowrap;\n']);

var StyledLink$1 = styled('a')(_templateObject$6, function (props) {
	return props.theme.colours.links;
}, function (props) {
	return props.theme.fonts.emailLink;
}, function (props) {
	return props.theme.name === 'vm' ? 'none' : 'underline';
});

/**
 * Uses `<a>` tag internally, the href is prefixed with "tel:"
 * @example ./Design.md
 */
var PhoneLink = function PhoneLink(_ref) {
	var linkText = _ref.linkText,
	    phoneNumber = _ref.phoneNumber;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$1, hasCustomMargins: true, layout: 'inline' },
		React.createElement(
			StyledLink$1,
			{ href: 'tel:' + phoneNumber, title: linkText },
			linkText || phoneNumber
		)
	);
};

PhoneLink.propTypes = {
	/** Displayed text. */
	linkText: PropTypes.string,
	/** Phone number. */
	phoneNumber: PropTypes.string.isRequired
};

PhoneLink.defaultProps = {};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M95.802 3.212c0-.006.003-.013.003-.02l-.003-.018-.004-.176c0-.717-.31-1.347-.758-1.86-.057-.076-.099-.162-.166-.233-.067-.064-.157-.105-.234-.163C94.122.301 93.485 0 92.77.003h-.176L92.57 0c-.012 0-.022.006-.035.006L60.411.208c-1.67.006-3.016 1.443-3.007 3.212.003 1.77 1.363 3.196 3.033 3.19l24.48-.15-52.01 52.201a3.118 3.118 0 0 0 .02 4.422 3.147 3.147 0 0 0 4.44-.016l52.046-52.24.153 24.323c.01 1.667 1.453 3.01 3.232 2.998 1.775-.007 3.212-1.357 3.202-3.02l-.198-31.916zM83.18 86.348a3.2 3.2 0 0 1-3.2 3.2H9.598a3.2 3.2 0 0 1-3.2-3.2V15.964a3.2 3.2 0 0 1 3.2-3.199h41.59V6.367H6.398A6.4 6.4 0 0 0 0 12.765v76.782a6.4 6.4 0 0 0 6.399 6.399H83.18a6.399 6.399 0 0 0 6.398-6.399v-44.79h-6.398v41.59z" }));
});

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.888 4.096v8H8.336v71.996h72v-32h8v40h-88V4.096zM92.464.364v24h-8l-.001-10.344-20.201 20.203a44.03 44.03 0 0 1-11.88 8.338A80.542 80.542 0 0 1 56 67.266V76h-8v-8.734A73.774 73.774 0 0 0 44.969 45.5a61.199 61.199 0 0 1-11.586 2.414 13.904 13.904 0 0 1-11.445-4.016l-.297-.33c-4.983-5.435-4.998-13.773-.036-19.226l.29-.32c5.471-5.46 14.329-5.46 19.8 0a41.831 41.831 0 0 1 7.7 11.1 35.775 35.775 0 0 0 9.21-6.556L78.807 8.364H68.464v-8zM27.695 29.537a6.278 6.278 0 0 0 .047 8.848 5.953 5.953 0 0 0 4.758 1.578 53.648 53.648 0 0 0 9.48-1.908 32.764 32.764 0 0 0-5.773-8.211 6.08 6.08 0 0 0-8.512-.307z" }));
});

var getPopoutOutlineLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var _templateObject$7 = taggedTemplateLiteral(['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n'], ['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n']);

var StyledVisuallyHiddenText = styled('span')(_templateObject$7);

var VisuallyHiddenBody = function VisuallyHiddenBody(_ref) {
	var children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledVisuallyHiddenText,
		{ id: id, 'data-test-id': dataTestId },
		children
	);
};

VisuallyHiddenBody.propTypes = {
	/** The id of the component. */
	id: PropTypes.string,
	/** Content of the visually hidden span. */
	children: PropTypes.node,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

var main$2 = "WebsiteLink.js";
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$8 = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n'], ['\n\tcolor: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n']);

var StyledIcon = styled('span')(_templateObject$8, function (props) {
	return props.theme.isCompact ? '2px' : '4px';
}, function (props) {
	return props.theme.colours.links;
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
});

var StyledLink$2 = styled('a')(_templateObject2$4, function (props) {
	return props.theme.colours.links;
});

/**
 * When willOpenNewWindow is true `<a>` tag will have `rel = noopener noreferrer`.
 * @example ./Design.md
 */
// eslint-disable-next-line react/prop-types
var WebsiteLink = function WebsiteLink(_ref) {
	var linkText = _ref.linkText,
	    linkTitle = _ref.linkTitle,
	    theme = _ref.theme,
	    url = _ref.url,
	    willOpenNewWindow = _ref.willOpenNewWindow,
	    visuallyHiddenText = _ref.visuallyHiddenText;

	var target = willOpenNewWindow ? '_blank' : '_self';
	var PopoutIcon = getPopoutOutlineLarge(theme.name);

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'inline' },
		React.createElement(
			StyledLink$2,
			{
				href: '' + url,
				target: target,
				title: linkTitle,
				rel: willOpenNewWindow ? 'noopener noreferrer' : null
			},
			React.createElement(
				'span',
				null,
				linkText || url
			),
			willOpenNewWindow ? React.createElement(
				'span',
				null,
				React.createElement(
					VisuallyHiddenBody,
					null,
					visuallyHiddenText ? visuallyHiddenText : '(Opens in a new tab)'
				),
				React.createElement(
					StyledIcon,
					null,
					React.createElement(PopoutIcon, null)
				)
			) : visuallyHiddenText && React.createElement(
				VisuallyHiddenBody,
				null,
				visuallyHiddenText
			)
		)
	);
};

WebsiteLink.propTypes = {
	/** Displayed text. */
	linkText: PropTypes.string,
	/** Native 'a' title attribute text. */
	linkTitle: PropTypes.string,
	/** Website url. */
	url: PropTypes.string.isRequired,
	/* Opens link in a new tab or window when clicked. */
	willOpenNewWindow: PropTypes.bool,
	/** Visually hidden text for accessibility. */
	visuallyHiddenText: PropTypes.string
};

WebsiteLink.defaultProps = {
	willOpenNewWindow: false
};

var WrappedWebsiteLink = withTheme(WebsiteLink);

export { EmailLink, PhoneLink, WrappedWebsiteLink as WebsiteLink };
